'use strict'

import React from 'react'
import { TextInput, View, StyleSheet } from 'react-native'
import FSText from 'app/fs/components/FSText'
import { colors } from 'app/fs/lib/styles'

export default class UrlEditor extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value || ''
    }
  }

  handleChangeEvent = event => {
    var val = event.nativeEvent.text
    this.setState({
      value: val
    })
    this.props.onChange(val)
  }

  renderValidationInfo = () => {
    if (this.props.errors) {
      return this.props.errors.map(e => {
        return (
          <FSText key={e} style={styles.validationError}>
            {e}
          </FSText>
        )
      })
    }
  }

  render() {
    return (
      <View style={styles.container}>
        <TextInput
          keyboardType="url"
          value={this.state.value}
          autoCapitalize={'none'}
          placeholder={this.props.placeholder || 'http://'}
          autoCorrect={false}
          returnKeyType={'done'}
          onSubmitEditing={event => this.props.onDone(event.nativeEvent.text)}
          onChange={this.handleChangeEvent}
          multiline={false}
          autoFocus={true}
          maxLength={this.props.maxLength || 2083}
          style={styles.input}
        />

        {this.renderValidationInfo()}
      </View>
    )
  }
}

var styles = StyleSheet.create({
  container: {
    flex: 1
  },
  input: {
    height: 50,
    paddingHorizontal: 15,
    fontSize: 16,
    borderWidth: 1,
    borderColor: colors.lightMediumGray
  },
  validationError: {
    paddingVertical: 5,
    paddingHorizontal: 15,
    backgroundColor: colors.red,
    color: colors.white,
    marginBottom: 1
  }
})
